import React from 'react';
import { Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import VendorMultiSelect from './VendorMultiSelect';
// Managed product components
import PropTypes from 'prop-types';

export default function AWSFilters({
  vendorEventScopes = [],
  setVendorEventScopes,
  vendorEventScopeOptions = [],
  isSubmitted
}) {
  // Prioritiy
  // Generic function to handle react-select single/multi-selects
  function handleSelectChange(e, setHook) {
    const selected = e || [];
    if (Array.isArray(selected)) setHook(selected.map(el => el));
    else setHook(selected);
  }
  return (
    <Card bg={'light'} text={'dark'} style={{}} className="mb-4">
      <CardBody>
        <>
          <CardTitle>Select Event Scopes to Monitor</CardTitle>
          <CardText>Select multiple entries if necessary</CardText>
          <Row form>
            <Col lg="5">
              <VendorMultiSelect
                options={vendorEventScopeOptions}
                setHook={setVendorEventScopes}
                categories={vendorEventScopes}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a scope'}
                name={'Event Scopes'}
                required={true}
              />
            </Col>
          </Row>
          <br />
        </>
      </CardBody>
    </Card>
  );
}

AWSFilters.propTypes = {
  vendorEventScopeOptions: PropTypes.array,
  handleSelectChange: PropTypes.func,
  setVendorEventScopes: PropTypes.func,
  vendorEventScopes: PropTypes.array,
  isSubmitted: PropTypes.bool
};
